import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';

import Tooltip from 'rc-tooltip';

import FormActionsGroup from '../form/form_actions_group.jsx';
import { InputGroup } from './input_group';

import { FormStore } from '../../reflux/form_store';
import SearcherModal from '../../../searcher/components/searcher_modal';

import { Skeleton } from '../indicators/skeleton';

import { ActivityFormEventHandler, ActivityFormEvents } from '../../../process/events/activity_form_event_handler';
import { FormEvents, FormEventHandler, FormElements } from '../../../form/events/form_event_handler';

import DocumentModal from '../../../document/components/modal/document_modal';
import ImportMultipleModal from '../../../document/components/modal/ImportMultipleModal';
import ImportMultipleGridModal from '../../../document/components/modal/ImportMultipleGridModal';

import { FormAPI, ProcessAPI } from 'lecom-api';

import { getParamUrl } from '../../../utils/query_string_parser';

import { ModalActions } from '../../../realize_overrides/stores/modal_store';

import { ReactComponent as IcoImportMultiple } from '../../../../../../icons/upload-files-icon.svg';

import { SearcherStore } from "../../../searcher/reflux/searcher_store";

const processMultiple = getParamUrl("processMultiple") === "true";
let mutationInterval = null;

// @connectToStore(FormStore)
@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.FormErrorHandlerMixin)
@mixin.decorate(window.FormSuccessHandlerMixin)
@mixin.decorate(Reflux.listenTo(FormStore, "onFormStoreLoad"))
export default class FormApp extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		definitionURL: PropTypes.string,
		definitionParams: PropTypes.object,
		loadOnInit: PropTypes.bool,
		waitingForAction: PropTypes.bool,
		readOnly: PropTypes.bool,
		isMobile: PropTypes.bool,
		isECMLicenseFull: PropTypes.bool,
		dataPrintEnabled: PropTypes.bool,
		highContrast: PropTypes.bool
	};

	static defaultProps = {
		id: null,
		definitionURL: "",
		definitionParams: {},
		formLoaded: true,
		loadOnInit: true,
		waitingForAction: false,
		readOnly: false,
		isMobile: false,
		dataPrintEnabled: false,
		highContrast: false
	};			

	componentDidMount() {
		this.setMutationObserver();				
	}

	componentWillUnmount() {
		clearInterval(mutationInterval);
	}

	componentDidUpdate(){								
		setTimeout(() => { this.focusRequiredInput() }, 800);
	}

	setMutationObserver() {
		mutationInterval = setInterval(() => {
			FormEventHandler.publish(FormEvents.MUTATION_OBSERVER);						
		}, 1000);
	}

	onFormStoreLoad(store, callback) {
		if (store && store.id === this.props.id) {
			if (callback) {
				this.setState(store, callback);
			} else {
				this.setState(store);
			}
		}

		if(store && store.formLoaded === true && store.formId === undefined){
			const formAPI = FormAPI.form(this.state.id);

			if (Array.isArray(formAPI.fields()) && formAPI.fields().length) {
				this.focusFirstFieldForm();
				this.tabOrderGroup();
			}
		}
	}

	parseActionsProp(actions = this.state.actions) {
		return this.isReadOnly() ? [] : actions.map(action => {
			let childrenActions = action.actions;
			let actionProps = Object.assign({}, action);
			//TODO: Por que children actions?
			if(!!childrenActions) {
				Object.assign(actionProps, {
					actions: this.parseActionsProp(childrenActions)
				});
			}

			return actionProps;
		});

	}

	isReadOnly() {
		return this.state && typeof this.state.readOnly !== 'undefined' ? this.state.readOnly : this.props.readOnly;
	}

	handleBackButtonClick() {
		ActivityFormEventHandler.publish(ActivityFormEvents.BACK_TO_START);
	}

	hasMessageInput() {
		let fields = this.state.fields;
		let required = false;
		let warning = false;

		for (let field in fields) {
			if (fields[field].warnings) {
				warning = true;
			}

			if(fields[field].type === "GRID") {
				const grindFilds = fields[field].fields;
				for (let grindField in grindFilds) {
					if (grindFilds[grindField].warnings) {
						warning = true;
					}
				}
			}

			for (let cont = 0, len = fields[field].validations.length; cont < len; cont++) {
				if (fields[field].validations[cont].hasOwnProperty("required") && fields[field].validations[cont].required) {
					required = true;
				}
			}
		}

		return { required, warning };
	}

	renderInputMessage() {
		let hasMessage = this.hasMessageInput();
		let arrMessage = [];

		if (hasMessage.required)
			arrMessage.push(<p className="form-required" tabIndex="0">{Realize.i18n.t('form.messages.info_required')}</p>);

		if (hasMessage.warning)
			arrMessage.push(<p className="form-warning" tabIndex="0">{Realize.i18n.t('form.messages.info_warning_external_manipulation')}</p>);

		return arrMessage;
	}

	focusBtnBack(){
		setTimeout(() => {
			let btnVisible = $('.btn-back').length ?  $('.btn-back').is(':visible') : [];

			if(btnVisible === true){
				let btnBack = $('.btn-back');

				btnBack.attr('tabindex', '0').focus();
				btnBack.keypress((e) => {
					if(e.keyCode === 13)
						e.currentTarget.click();
				})
			}
		}, 100)
	}

	renderBackButton() {
		const currentProcess = ProcessAPI.currentProcess();
		const isMobile = currentProcess.isMobile();
		const isPublic = currentProcess.isPublic();

		this.focusBtnBack();

		if (isMobile || isPublic || processMultiple)
			return <span />;

		return (
			<Button
				name={Realize.i18n.t('actions.back')}
				element="a"
				role='button'
				icon="replay"
				onClick={this.handleBackButtonClick}
				className="btn-back"/>
		);
	}

	renderLookupModal() {
		let propsSearcher = {
			headerTitle: 'Lupa',
			buttonName: 'Enviar',
			selectionEmptyMessage: 'Não é possível preencher o formulário sem dados selecionados na tabela.',
			modal: {},
			closeButton: { name: 'Fechar', style: 'cancel', icon: 'clear' },
			filterValues: {},
			results: [],
			page: {},
			searcher: {},
			isLoading: false,
			lookupType: '',
			forwardedProps: {},
			uniqueStoreItemId: "",
			updateUUID: "",
			isMobile: this.props.isMobile
		}		
		
		if (SearcherStore._uniqueStoreItemId) {			
			const storeSearcher = SearcherStore.store[SearcherStore._uniqueStoreItemId];
			
			propsSearcher.headerTitle = storeSearcher.headerTitle;
			propsSearcher.buttonName = storeSearcher.buttonName;
			propsSearcher.selectionEmptyMessage = storeSearcher.selectionEmptyMessage;
			propsSearcher.modal = storeSearcher.modal;
			propsSearcher.closeButton = storeSearcher.closeButton;
			propsSearcher.filterValues = storeSearcher.filterValues;
			propsSearcher.results = storeSearcher.results;
			propsSearcher.page = storeSearcher.page;
			propsSearcher.searcher = storeSearcher.searcher;
			propsSearcher.isLoading = storeSearcher.isLoading;
			propsSearcher.lookupType = storeSearcher.lookupType;
			propsSearcher.forwardedProps = storeSearcher.forwardedProps;
			propsSearcher.uniqueStoreItemId = storeSearcher.uniqueStoreItemId;
			propsSearcher.updateUUID = storeSearcher.updateUUID;			
		}
		
		return (
			<div className="searcher-field__modals-wrapper">
				<SearcherModal {...propsSearcher} />
			</div>
		)
	}

	renderDocumentModal() {
		return (
			<div className="document-field__modals-wrapper">
				<DocumentModal
					formId={this.props.id}
					isMobile={this.props.isMobile} />
			</div>
		)
	}	

	// FOCO INITIAL FORM FIELD
	focusFirstFieldForm(){
		const formAPI = FormAPI.form(this.state.id);
		let idField = formAPI.fields()[0].id;
		let fieldDisabled = formAPI.fields()[0].disabled();
		let fieldReadOnly = formAPI.fields()[0].readOnly();

		let filterGridType = this.state.fieldsGroupings[0].fields.filter(f => f.gridFormParent === idField);
		$(".form-required").attr('tabindex', 0);
		$(".form-warning").attr('tabindex', 0);

		if(filterGridType.length > 0){
			let idGrid = filterGridType[0].gridFormParent;
			let idField = filterGridType[0].id;
			let typeFieldGrid = formAPI.fields(idGrid).fields()[0].type();
			let fields = formAPI.fields(idGrid).fields()[0].id;

			if(typeFieldGrid === 'DOCUMENT'){
				let firstButtonsDoc = $(`#input__${fields} .document-action-buttons .button`);
				if(firstButtonsDoc.length > 0)
					firstButtonsDoc.focus();
			}

			else if(typeFieldGrid === 'AUTOCOMPLETE'){
				let inputList = $(`#input__${fields} .input-autocomplete .select-wrapper span`);
				inputList.attr('tabindex', '0').focus();
			}

			else if(typeFieldGrid === 'RADIO'){
				let checkboxInput = $(`#input__${idField} input`);
				let radioB = $(`#input__${idField} .input-checkbox-group p label`);

				checkboxInput.css("visibility", "visible");
				radioB.attr('tabindex', '0');
				radioB[0].focus();
			}

			else if(typeFieldGrid === 'CHECKBOX'){
				let checkboxInput = $(`#input__${idField} input`);
				let checkboxLabel = $(`#input__${idField} .label`);

				checkboxInput.css("visibility", "visible");
				checkboxLabel.attr('tabindex', '0').focus();
			}

			else {
				formAPI.fields(idGrid).fields()[0].focus()
			}
		}
		else if(!fieldDisabled){
			let typeField = formAPI.fields()[0].type();

			if(typeField !== 'DOCUMENT' || typeField !== 'AUTOCOMPLETE' || typeField !== 'RADIO' || typeField !== 'CHECKBOX' || typeField !== 'LABEL'){
				let inputField = $(`#${idField}`);
				inputField.focus();
			}

			if(typeField === 'DOCUMENT'){
				let firstButtonsDoc = $(`#input__${idField} .document-action-buttons .button`);
				if(firstButtonsDoc.length > 0)
					firstButtonsDoc.focus();
			}

			if(typeField === 'AUTOCOMPLETE'){
				if(formAPI.fields()[0].readOnly() !== true){
					let inputList = $(`#input__${idField} .input-autocomplete .select-wrapper span`);
					inputList.attr('tabindex', '0').focus();

					inputList.unbind('keydown').keydown((e) => {
						if(e.which === 13)
							e.currentTarget.click();
					})
				}
				else {
					let inputList = $(`#input__${idField} .input-autocomplete .select-wrapper`);
					inputList.attr('tabindex', '-1').focus();
				}
			}

			if (typeField === 'CHECKBOX') {
				let checkboxInput = $(`#input__${idField} input`);
				let checkboxLabel = $(`#input__${idField} .label`);

				checkboxInput.css("visibility", "visible");
				checkboxLabel.attr('tabindex', '0').focus();
			}

			if(typeField === 'RADIO'){
				let checkboxInput = $(`#input__${idField} input`);
				let radioB = $(`#input__${idField} .input-checkbox-group p label`);

				checkboxInput.css("visibility", "visible");
				radioB.attr('tabindex', '0');
				radioB[0].focus();
			}

			if(typeField === 'LABEL'){
				let label = $(`#label__${idField}`);
				label.attr('tabindex', '0').focus();
			}
		}
	}

	tabOrderGroup(){
		$(".form-required").attr('tabindex', 0);
		let groupExpansibleLength = $('.group-expansible').length;
		if(groupExpansibleLength > 0){
			$('.group-expansible').keypress((e) => {
				if(e.which === 13 || e.keyCode === 13){
					e.currentTarget.click();
				}
			})
		}

		$(".container-import-multiple a").attr('tabindex', 0).off('keypress').on('keypress', (e) => {
			if(e.which === 13 || e.keyCode === 13){
				e.currentTarget.click();
			}
		});

		$(".container-import-multiple-grid a").attr('tabindex', 0).off('keypress').on('keypress', (e) => {
			if(e.which === 13 || e.keyCode === 13){
				e.currentTarget.click();
			}
		});		
	}

	focusNextElement () {
		//add all elements we want to include in our selection
		var focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
		if (document.activeElement && document.forms[0]) {
			var focussable = Array.prototype.filter.call(document.forms[0].querySelectorAll(focussableElements),
			function (element) {
				//check for visibility while always include the current activeElement
				return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
			});
			var nextElement = focussable[0];
			nextElement.focus();
		}
	}

	handlerClick() {
		Form.flagError(false).apply();
	}

	renderImportMultipleModal() {
		return (			
			<ImportMultipleModal isMobile={this.props.isMobile} />			
		)
	}

	renderImportMultipleGridModal() {
		return (			
			<ImportMultipleGridModal isMobile={this.props.isMobile} />
		)
	}

	focusRequiredInput(){
		let msgRequiredIsVisible = $('.flash--error').is(':visible');
		let iconRequired = $('.flash--error .card-action');
		let msgSuccessVisible = $('.flash--success').is(':visible');

		if(msgRequiredIsVisible === true || msgSuccessVisible === true){
			let msgError = $('.flash--error .card-content div');
			msgError.attr('tabindex', '0');

			let msgErrorLength = $('.flash--error').length;
			var flashDismiss = $('.flash--error .flash__dismiss');

			flashDismiss.attr('aria-label', Realize.i18n.t('erro.button.close')).attr('role', 'button');
			$('.flash--error .flash__dismiss i').attr('aria-hidden', true);
			flashDismiss.unbind('click').on('click', this.handlerClick.bind(this));

			if(msgErrorLength > 1){
			} else {
				if(msgSuccessVisible === false)
					msgError.attr('tabindex', '0');
				else{
					let verifyMsgFinalActivity = $('.flash--success .final-activity-message').length ? $('.flash--success .final-activity-message').is(':visible') : false;
					let isModal = false;
						const listModal = document.querySelectorAll('.realize-modal');
						Array.prototype.forEach.call(listModal, function(modal){
							if(modal.style.display === "block"){
								isModal = true
							}
						});

					if(verifyMsgFinalActivity === true){
						let msgFinalActivity = $('.flash--success .final-activity-message');
						msgFinalActivity.attr('tabindex', '0');
					}
				}
			}

			iconRequired.attr('tabindex', '0');
			iconRequired.keypress((e) => {
				if(e.which === 13 || e.which === 32){
					iconRequired[0].click();
					this.focusNextElement();
				}
			});
		}
	}

	renderInputs() {
		var inputs = this.state.fields || {};		

		if(!inputs || $.isEmptyObject(inputs)) {
			return [];
		}						

		return (			
			<InputGroup
				inputs={inputs}
				contextType='FORM'
				isMobile={this.props.isMobile}
				disabled={this.props.disabled}
				readOnly={this.isReadOnly()}
				formStyle="default"
				errors={this.state.errors}
				ref="inputGroup"					
			/>							
		);
	}

	renderActions() {
		return this.isReadOnly() ?
			null :
			<FormActionsGroup
				actions={ this.state.actions}
				inputs={this.state.fields}
				isMobile={this.props.isMobile}
				isLoading={this.state.waitingForAction}
			/>
	}

	getDisable() {
		// 'hide'
		return this.state.enableForm ? '' : 'hide';
	}

	formSubmit(event) {
    	event.preventDefault();
	}

	importMultipleClick() {				
		ModalActions.open({ modalId: "importMultipleModal" });
	}

	hasFieldsDocument() {		
		const fields = this.state && this.state.fields ? this.state.fields : {};		
		let hasFieldDocument = false;

		for (const key in fields) {
			const field = fields[key];

			if (field.type === "DOCUMENT") {
				if (field.canImport && field.visible && !field.readOnly && !field.disabled) {
					hasFieldDocument = true;
					break;
				}
			}
			else if (field.type === "GRID") {
				const fieldsDocument = (field.fields || []).filter(f => f.type === "DOCUMENT" && f.canImport && f.visible && !f.readOnly && !f.disabled);
				
				if (fieldsDocument.length) {
					hasFieldDocument = true;
					break;
				}
			}
		}

		return hasFieldDocument;
	}

	render() {		
		if(this.state.formLoadedWithErrors) {
			return (
				<div>{this.renderBackButton()}</div>
			);
		}

		if((!this.state.formLoaded && !this.state.formLoadedWithErrors)) {
			FormEventHandler.publish(FormEvents.FORM_LOAD_START, FormElements.FORM, this.props);
			return <Skeleton />;			
		}else if(this.state.formLoaded) {
			FormEventHandler.publish(FormEvents.FORM_LOAD_FINISH, FormElements.FORM, this.props);
		}

		return (
			<div data-testid="form">
				{this.hasFieldsDocument() &&				
					<div className='container-import-multiple'>		
						<Tooltip placement="left" overlay={Realize.i18n.t('importMultipleModal.modalTitle')} showArrow={false}>
							<a className="button btn waves-effect waves-light button--icon button-cancel black-text grey lighten-4" onClick={this.importMultipleClick}>
								<IcoImportMultiple alt="" title="" />
							</a>
						</Tooltip>				
					</div>
				}

				{this.state.flagError && this.renderFlashErrors()}
				{this.renderInputMessage()}

				<form id={this.props.id} className='form row' ref="form" onSubmit={this.formSubmit.bind(this)}>
					{this.renderFlashSuccess()}
					{this.renderInputs()}					
					{this.renderActions()}
				</form>

				{this.renderLookupModal()}
				{this.renderDocumentModal()}
				{this.renderImportMultipleModal()}
				{this.renderImportMultipleGridModal()}
			</div>
		)
	}
}
